import { createSelector } from 'reselect';

import { hasUndoLockSelector } from '/business/shared/state/selectors/application/basket_meta/getBasketMetaSelector';

export default createSelector([hasUndoLockSelector], (...results) => {
  return results.every((item) => item);
});
